<template>
  <div>
    <b-col cols="12">
      <SearchCard
        ref="searchInterviewReady"
        :filterCatch="true"
        :title="$lang.interview_ready"
        :url="url"
        :html="false"
        :hasUploadExcel="true"
        :sampleDownload="$lang.interview_ready_sample_download"
        :uploadExcelTooltip="$lang.interview_ready_attachFile"
        @handleUploadExcel="importExcelModal"
      >
        <template slot="html" slot-scope="{ item }">
          <b-col
            cols="12"
            class="py-1 border-bottom d-md-flex d-block align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <span
                v-b-tooltip.hover
                class="badge badge_ticket badge-danger badge-pill"
              ></span>
              <span
                class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle-sms d-flex align-items-center justify-content-center"
                v-b-tooltip.hover
                :title="``"
              >
                <i class="fas fa-folder-open text-success"></i>
              </span>
              <b class="px-1 fs_1rem" v-text="item.term_caption" />
            </div>
          </b-col>
          <b-col cols="12" md="2" class="text-center my-2">
            <b-img-lazy
              fluid
              thumbnail
              :onerror="$config.images.onerrorDefaultImg"
              :src="
                item.person && item.person.pic_url
                  ? item.person.pic_url
                  : `${$config.images.tinyLogo}`
              "
              class="bg-white"
              width="80"
            />
          </b-col>
          <b-col cols="12" md="10" class="my-2">
            <b-row>
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b> {{ $lang.parvande_number }}: </b>
                {{ item.parvandeh && item.parvandeh.parvandeh_number }}</b-col
              >
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b>{{ $lang.name_family }} :</b>
                <ProfileBoxPopupWrapper
                  :data="item"
                  deskTopPopupClass="top-230"
                  nameClass="color-complementary"
                />
              </b-col>
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b> {{ $lang.natinal_code }}:</b>
                {{ item.person && item.person.national_code }}</b-col
              >
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b> {{ $lang.number_interview_plan }}:</b>
                {{ item.interview_planned }}</b-col
              >
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b> {{ $lang.number_interview_doing }} :</b>
                {{ item.interview_in_progress }}</b-col
              >
              <b-col cols="12" md="4">
                <i class="far fa-check-circle mr-1" />
                <b>{{ $lang.number_interview_done }} :</b>
                {{ item.interview_done_completed }}</b-col
              >
            </b-row>
          </b-col>

          <b-col cols="12" md="12" class="py-1 mt-3 border-top">
            <b-row align-v="center" align-h="between" class="w-100 m-0">
              <b-col cols="12" md="" class="text-right px-0">
                <b-button variant="outline-success" size="sm">
                  <i class="fas fa-clock fa-lg mr-1" />
                  <b v-text="$lang.enter_time" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </template>
      </SearchCard>
    </b-col>

    <b-modal
      no-close-on-backdrop
      v-model="isImportFile"
      :title="$lang.add_user_role_tooltip"
      size="xl"
      hide-header
      hide-footer
    >
      <ShowCardUpload
        :url="uploadExcelUrl"
        :showAlert="exampleFileLink"
        @closeModal="isImportFile = false"
        @getItems="getItems"
      />
    </b-modal>
  </div>
</template>

<script>
import { ProfileBoxPopupWrapper } from "@/components/re-design";
import SearchCard from "@/components/base/searchCard";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  props: {},
  components: {
    SearchCard,
    ShowCardUpload,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      isImportFile: false,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["interview", "interview_ready"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["interview", "import_interview_location_person"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_interview_sample_excel.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  methods: {
    pathOr,
    getItems() {
      this.$refs.searchInterviewReady.getItems();
      this.isImportFile = false;
    },
    importExcelModal() {
      this.isImportFile = true;
    },
    closeIsImportFile() {
      this.$refs.fileDrag.$refs.fileUpload = [];
      this.isImportFile = false;
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
  },
};
</script>

<style scoped></style>
